/* ar-narrow — on-page "narrow these results" filter for collections & search.
 * Searches the WHOLE collection (not just the current page) by lazily fetching a
 * lightweight JSON index (templates/collection.narrow.liquid via ?view=narrow),
 * caching it, filtering client-side, and rendering matching ar-cards into the grid.
 *
 * Resilient by design: the theme's sort/show/filter AJAX (collection-filters-form.js
 * / theme.min.js) REPLACES #CollectionProductGrid's innerHTML — which contains our
 * input — so we use document-level event delegation (survives the input being
 * recreated) and a MutationObserver that resets our state when the theme swaps the
 * grid. Also guards document.title, which the theme's AJAX clobbers to the URL. */
(function () {
  'use strict';

  // ---- title guard: theme AJAX sort/show/filter clobbers document.title. It may set it to a
  // path ("/collections/x?..."), a full URL, or EMPTY (browser then shows the URL in the tab).
  // The page never legitimately changes its title without a full navigation, so restore the
  // captured good title whenever it goes empty or URL-like. ----
  (function () {
    var titleEl = document.querySelector('title');
    var good = (document.title || '').trim();
    function looksBad(t) {
      t = (t || '').trim();
      if (t === good) return false;
      if (!t) return true;                                   // empty → browser falls back to URL
      if (/^(https?:\/\/|www\.|\/)/i.test(t)) return true;   // path or full URL
      if (t.indexOf('/collections/') > -1 || t.indexOf('/search') > -1) return true;
      try { if (location.host && t.indexOf(location.host) > -1) return true; } catch (e) {}
      return false;
    }
    if (!titleEl || !good || looksBad(good)) return;
    new MutationObserver(function () {
      if (looksBad(document.title)) document.title = good;
    }).observe(titleEl, { childList: true, characterData: true, subtree: true });
  })();

  if (!document.querySelector('[data-ar-narrow]')) return;

  // ---- state ----
  var index = null, loadPromise = null, cachedKey = null;
  var narrowActive = false, originalHTML = null, statusEl = null, currentTerm = '';
  var pagerEl = null, narrowMatches = null, currentPage = 1;

  // ---- fresh DOM lookups (elements get replaced by theme AJAX) ----
  function getRoot() { return document.querySelector('[data-ar-narrow]'); }
  function getInput() { var r = getRoot(); return r && r.querySelector('[data-ar-narrow-input]'); }
  function getGridWrap() { return document.getElementById('main-collection-product-grid'); }
  function getGrid() { var w = getGridWrap(); return w && w.querySelector('.halo-column-product'); }
  function ctx() {
    var r = getRoot(); if (!r) return null;
    var isSearch = r.hasAttribute('data-search');
    var coll = r.getAttribute('data-collection');
    return { isSearch: isSearch, basePath: isSearch ? '/search' : (coll ? '/collections/' + encodeURIComponent(coll) : null) };
  }

  function currentParams() {
    var p = new URLSearchParams(location.search);
    p.delete('page'); p.delete('view');
    return p.toString();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function ensureStatus() {
    if (statusEl && statusEl.isConnected) return statusEl;
    var wrap = getGridWrap(); if (!wrap) return null;
    statusEl = document.createElement('div');
    statusEl.className = 'ar-narrow-status';
    statusEl.setAttribute('data-ar-narrow-status', '');
    // Insert INSIDE the grid wrap (not as a sibling in #CollectionProductGrid) so our own
    // DOM write doesn't register as a child-list change on the node the observer watches.
    wrap.insertBefore(statusEl, wrap.firstChild);
    return statusEl;
  }
  // Hide/show the THEME's native pagination (show-more + numbered). Excludes our own pager,
  // which reuses .pagination-wrapper markup but is tagged data-ar-narrow-pagination.
  function paginationHidden(hidden) {
    var wrap = getGridWrap(); if (!wrap) return;
    var sels = wrap.querySelectorAll('.infinite-scrolling, .pagination-wrapper');
    for (var i = 0; i < sels.length; i++) {
      if (sels[i].hasAttribute('data-ar-narrow-pagination')) continue;
      if (hidden) sels[i].style.setProperty('display', 'none', 'important');
      else sels[i].style.removeProperty('display');
    }
  }

  // page size: follow the storefront's current "Show" selection, fall back to a sane default.
  function getPageSize() {
    var sel = document.getElementById('showPagination') || document.querySelector('select[name="paginateBy"]');
    var n = sel ? parseInt(sel.value, 10) : NaN;
    return (n && n > 0) ? n : 24;
  }
  function ensurePager() {
    if (pagerEl && pagerEl.isConnected) return pagerEl;
    var wrap = getGridWrap(); if (!wrap) return null;
    pagerEl = document.createElement('div');
    pagerEl.setAttribute('data-ar-narrow-pagination', '');
    wrap.appendChild(pagerEl);
    return pagerEl;
  }
  function removePager() { if (pagerEl) { pagerEl.remove(); pagerEl = null; } }
  // Windowed page numbers: 1 … (n-1) n (n+1) … last
  function pageParts(page, pages) {
    var parts = [], i;
    var lo = Math.max(2, page - 1), hi = Math.min(pages - 1, page + 1);
    parts.push(1);
    if (lo > 2) parts.push('…');
    for (i = lo; i <= hi; i++) parts.push(i);
    if (hi < pages - 1) parts.push('…');
    if (pages > 1) parts.push(pages);
    return parts;
  }
  function pagerHTML(total, page, pageSize) {
    var pages = Math.ceil(total / pageSize);
    if (pages <= 1) return '';
    var from = (page - 1) * pageSize + 1, to = Math.min(page * pageSize, total);
    var h = '<div class="pagination-wrapper ar-narrow-pagination" data-ar-narrow-pagination>';
    h += '<div class="page-total">' + from + ' - ' + to + ' of ' + total.toLocaleString() + '</div>';
    h += '<ul class="list--inline pagination">';
    h += page > 1
      ? '<li><a href="#" class="btn btn--narrow btn--prev" data-ar-narrow-page="' + (page - 1) + '" aria-label="Previous"><span class="icon_text">Previous</span></a></li>'
      : '<li aria-hidden="true"><button class="btn btn--narrow btn--prev" disabled><span class="icon_text">Previous</span></button></li>';
    pageParts(page, pages).forEach(function (pt) {
      if (pt === '…') h += '<li><span class="pagination-link">…</span></li>';
      else if (pt === page) h += '<li><span class="pagination-link pagination--current">' + pt + '</span></li>';
      else h += '<li><a href="#" class="pagination-link" data-ar-narrow-page="' + pt + '" aria-label="page ' + pt + '">' + pt + '</a></li>';
    });
    h += page < pages
      ? '<li><a href="#" class="btn btn--narrow btn--next" data-ar-narrow-page="' + (page + 1) + '" aria-label="Next"><span class="icon_text">Next</span></a></li>'
      : '<li aria-hidden="true"><button class="btn btn--narrow btn--next" disabled><span class="icon_text">Next</span></button></li>';
    h += '</ul></div>';
    return h;
  }

  function priceHTML(p) {
    if (p.cap) {
      return '<div class="product-price price--on-sale">' +
        '<span class="price-item price-item--sale">' + esc(p.price) + '</span> ' +
        '<span class="price-item price-item--regular" data-regular-price>' + esc(p.cap) + '</span></div>';
    }
    return '<div class="product-price"><span class="price-item price-item--regular" data-regular-price>' + esc(p.price) + '</span></div>';
  }
  // Stock logic mirrors snippets/ar-card.liquid + product-template.liquid so filtered cards,
  // the grid, and the product page never disagree. Untracked inventory (!itrk) reads "In stock";
  // backorder/special/unavailable only apply when inventory IS tracked.
  function stockHTML(p) {
    var status = 'in-stock', label = 'In stock', low = false;
    if (p.itrk) {
      if (p.inv > 0) { status = 'in-stock'; if (p.inv <= 5) { label = 'Only ' + p.inv + ' left'; low = true; } else { label = 'In stock'; } }
      else if (p.av && p.so) { status = 'special-order'; label = 'Special order'; }
      else if (p.av) { status = 'backordered'; label = 'Backordered'; }
      else { status = 'unavailable'; label = 'Unavailable'; }
    }
    return '<div class="ar-card__stock ar-card__stock--' + status + (low ? ' ar-card__stock--low' : '') + '">' + label + '</div>';
  }
  function flagsHTML(p) {
    if (!p.carb && !p.frt) return '';
    return '<div class="ar-card__flags">' +
      (p.carb ? '<span class="ar-card__flag ar-card__flag--carb" title="Not CARB compliant. Not legal for sale or use in California on emissions-controlled vehicles.">Not CARB Compliant</span>' : '') +
      (p.frt ? '<span class="ar-card__flag ar-card__flag--freight" title="Ships via LTL freight">Freight</span>' : '') +
      '</div>';
  }
  function detailsHTML(p) {
    var h = '';
    if (p.cat) h += '<div class="ar-card__meta"><span class="ar-card__meta-label">Category</span><span class="ar-card__meta-value">' + esc(p.cat) + '</span></div>';
    if (p.subcat) h += '<div class="ar-card__meta"><span class="ar-card__meta-label">Subcategory</span><span class="ar-card__meta-value">' + esc(p.subcat) + '</span></div>';
    if (p.sku) h += '<div class="ar-card__meta"><span class="ar-card__meta-label">SKU</span><span class="ar-card__meta-value">' + esc(p.sku) + '</span></div>';
    if (p.desc) { var t = p.t || ''; if (t.indexOf(p.desc) === -1 && p.desc.indexOf(t) === -1) h += '<p class="ar-card__desc">' + esc(p.desc) + '</p>'; }
    return '<div class="ar-card__details">' + h + '</div>';
  }
  // Add-to-cart parity with snippets/add-to-cart-btn.liquid (theme JS hooks data-btn-addToCart).
  function actionsHTML(p) {
    var fid = 'ar-narrow-form-' + p.vid, inner;
    if (!p.av) {
      inner = '<button class="btn product-btn product-btn-soldOut product-btn--unavailable" type="submit" disabled="disabled">Unavailable</button>';
    } else if (p.vc > 1) {
      inner = '<a class="btn product-btn product-btn--select-options" href="' + esc(p.u) + '" aria-label="button">Select Options</a>';
    } else {
      var cls = 'product-btn--in-stock', label = 'Add to Cart';
      if (p.itrk && !(p.inv > 0)) { if (p.so) { cls = 'product-btn--special-order'; label = 'Pre-Order'; } else { cls = 'product-btn--backordered'; label = 'Backorder'; } }
      inner = '<input type="hidden" name="id" value="' + p.vid + '"><input type="hidden" name="quantity" value="1">' +
        '<button data-btn-addToCart class="btn product-btn ' + cls + '" type="submit" data-form-id="#' + fid + '">' + label + '</button>';
    }
    return '<div class="ar-card__actions"><div class="product-action">' +
      '<form action="/cart/add" method="post" class="variants" id="' + fid + '" data-id="product-actions-' + p.vid + '" enctype="multipart/form-data">' +
      inner + '</form></div></div>';
  }
  function cardHTML(p) {
    var img = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" loading="lazy">' : '';
    var path = p.subcat || p.cat;
    return '<div class="halo-item"><div class="ar-card' + (p.av ? '' : ' ar-card--sold-out') + '" data-ar-narrow-card>' +
      '<div class="ar-card__media"><a class="ar-card__link" href="' + esc(p.u) + '" aria-label="' + esc(p.t) + '">' + img + '</a></div>' +
      '<div class="ar-card__body">' +
      (p.v ? '<div class="ar-card__vendor">' + esc(p.v) + '</div>' : '') +
      '<h3 class="ar-card__title"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3>' +
      (path ? '<div class="ar-card__path">' + esc(path) + '</div>' : '') +
      detailsHTML(p) +
      '<div class="ar-card__price">' + priceHTML(p) + '</div>' +
      stockHTML(p) + flagsHTML(p) + actionsHTML(p) +
      '</div></div></div>';
  }

  function loadIndex() {
    var c = ctx(); if (!c || !c.basePath) return Promise.resolve(null);
    var key = currentParams();
    if (key !== cachedKey) { index = null; loadPromise = null; cachedKey = key; }
    if (index) return Promise.resolve(index);
    if (loadPromise) return loadPromise;
    var base = c.basePath + '?view=narrow' + (key ? '&' + key : '') + '&page=';
    loadPromise = fetch(base + '1', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.json(); })
      .then(function (first) {
        var pages = first.pages || 1;
        if (pages <= 1) return first.products;
        var reqs = [];
        for (var pg = 2; pg <= pages; pg++) { reqs.push(fetch(base + pg).then(function (r) { return r.json(); }).then(function (d) { return d.products; })); }
        return Promise.all(reqs).then(function (rest) {
          var all = first.products.slice();
          for (var i = 0; i < rest.length; i++) all = all.concat(rest[i]);
          return all;
        });
      })
      .then(function (all) { index = all; return index; })
      .catch(function () { loadPromise = null; return null; });
    return loadPromise;
  }

  function clearBtnHTML() {
    return '<button type="button" class="ar-narrow-status__reset" data-ar-narrow-reset>Clear</button>';
  }

  function render(term) {
    var grid = getGrid(); if (!grid) return;
    var c = ctx(), isSearch = c && c.isSearch;
    var tokens = term.trim().toLowerCase().split(/\s+/).filter(Boolean);
    narrowMatches = index.filter(function (p) { return tokens.every(function (t) { return p.s.indexOf(t) > -1; }); });
    currentTerm = term;
    paginationHidden(true);
    var st = ensureStatus(); if (!st) return;
    if (narrowMatches.length === 0) {
      grid.innerHTML = ''; removePager();
      var scope = isSearch ? 'these results' : 'this collection';
      var capped = isSearch && index.length >= 1000;
      var emptyMsg = capped
        ? 'No matches for “' + esc(term) + '” in the first ' + index.length.toLocaleString() +
          ' results. This search is broad, so only the first ' + index.length.toLocaleString() +
          ' can be searched here — try a more specific search, then narrow again. '
        : 'No matches for “' + esc(term) + '” in ' + scope + '. ';
      st.innerHTML = emptyMsg + clearBtnHTML();
      return;
    }
    renderPage(1, false);
  }

  // Render one page of the current narrow matches (client-side pagination so big result sets
  // stay paginated like the normal grid and never dump thousands of cards at once).
  function renderPage(n, doScroll) {
    var grid = getGrid(); if (!grid || !narrowMatches) return;
    var c = ctx(), isSearch = c && c.isSearch;
    var capped = isSearch && index.length >= 1000;
    var pageSize = getPageSize();
    var pages = Math.max(1, Math.ceil(narrowMatches.length / pageSize));
    n = Math.min(Math.max(1, n), pages); currentPage = n;
    var slice = narrowMatches.slice((n - 1) * pageSize, n * pageSize);
    grid.innerHTML = slice.map(cardHTML).join('');
    var st = ensureStatus();
    if (st) st.innerHTML = 'Showing <strong>' + narrowMatches.length + '</strong> of ' +
      index.length.toLocaleString() + (capped ? '+' : '') + ' for “' + esc(currentTerm) + '”. ' + clearBtnHTML();
    var pgr = ensurePager();
    if (pgr) { var html = pagerHTML(narrowMatches.length, n, pageSize); if (html) pgr.innerHTML = html; else removePager(); }
    if (doScroll) { var wrap = getGridWrap(); if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }

  function restore() {
    var grid = getGrid();
    if (grid && originalHTML != null) grid.innerHTML = originalHTML;
    removePager();
    paginationHidden(false);
    if (statusEl) { statusEl.remove(); statusEl = null; }
    var clear = getRoot() && getRoot().querySelector('[data-ar-narrow-clear]');
    if (clear) clear.hidden = true;
    narrowActive = false; originalHTML = null; currentTerm = ''; narrowMatches = null; currentPage = 1;
  }

  // theme replaced the grid (sort/show/filter). Our state + status lived in the old (now
  // detached) grid, so drop them. If a term was active, re-apply it to the fresh grid so the
  // narrowed results survive the sort/show change (re-fetched with the new params) instead of
  // silently reverting to the full list.
  function onGridSwap() {
    var term = currentTerm;
    narrowActive = false; originalHTML = null; currentTerm = '';
    statusEl = null; pagerEl = null; narrowMatches = null; currentPage = 1; // old nodes went away with the replaced grid
    if (!term || !term.trim()) return;
    var input = getInput(); if (input) input.value = term;
    var g = getGrid(); originalHTML = g ? g.innerHTML : null; narrowActive = true;
    currentTerm = term;
    var clear = getRoot() && getRoot().querySelector('[data-ar-narrow-clear]'); if (clear) clear.hidden = false;
    var st = ensureStatus(); if (st) st.textContent = (ctx() && ctx().isSearch) ? 'Searching the results…' : 'Searching the collection…';
    paginationHidden(true);
    loadIndex().then(function (idx) {
      if (!idx) return;
      var inp = getInput(); if (inp && inp.value !== term) return;
      render(term);
    });
  }

  // ---- delegated events (survive the input/grid being recreated by theme AJAX) ----
  var debounce;
  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-ar-narrow-input]')) return;
    var input = e.target;
    clearTimeout(debounce);
    var term = input.value;
    if (!term.trim()) { restore(); return; }
    if (!narrowActive) { var g = getGrid(); originalHTML = g ? g.innerHTML : null; narrowActive = true; }
    var clear = getRoot() && getRoot().querySelector('[data-ar-narrow-clear]'); if (clear) clear.hidden = false;
    currentTerm = term;
    debounce = setTimeout(function () {
      var st = ensureStatus(); if (st) st.textContent = (ctx() && ctx().isSearch) ? 'Searching the results…' : 'Searching the collection…';
      paginationHidden(true);
      loadIndex().then(function (idx) {
        if (input.value !== term) return;
        if (!idx) { var s = ensureStatus(); if (s) s.textContent = 'Could not load results. Try again.'; return; }
        render(term);
      });
    }, 220);
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    // our pagination links
    var pageLink = e.target.closest('[data-ar-narrow-page]');
    if (pageLink) {
      e.preventDefault();
      var n = parseInt(pageLink.getAttribute('data-ar-narrow-page'), 10);
      if (n && narrowMatches) renderPage(n, true);
      return;
    }
    if (e.target.closest('[data-ar-narrow-clear], [data-ar-narrow-reset]')) {
      var input = getInput(); if (input) input.value = '';
      restore();
      if (input) input.focus();
    }
  });

  // ---- watch the grid for theme AJAX replacement, then re-apply our filter ----
  function observeGrid() {
    var container = document.getElementById('CollectionProductGrid') || getGridWrap();
    if (!container) return;
    var lastWrap = getGridWrap();
    // childList only (not subtree): our own renders write deeper (.halo-column-product) and our
    // status now lives inside the wrap, so neither trips this. Only fire when the wrap NODE
    // itself is swapped — ignores unrelated direct-child churn (e.g. the loading-modal toggling).
    new MutationObserver(function () {
      var w = getGridWrap();
      if (w && w !== lastWrap) { lastWrap = w; onGridSwap(); }
    }).observe(container, { childList: true });
  }
  observeGrid();
})();
